import { render, staticRenderFns } from "./StaintEdit.vue?vue&type=template&id=3e4ba2c8&scoped=true&"
import script from "./StaintEdit.vue?vue&type=script&lang=ts&"
export * from "./StaintEdit.vue?vue&type=script&lang=ts&"
import style0 from "./StaintEdit.vue?vue&type=style&index=0&id=3e4ba2c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e4ba2c8",
  null
  
)

export default component.exports